const formatFileSize = (value: number | string) => {
    const number = Number(value);

    if (number >= 1024 * 1024) {
        return `${Math.floor(number / 1024 / 1024)} MB`;
    }

    if (number >= 1024) {
        return `${Math.floor(number / 1024)} KB`;
    }

    return `${number} B`;
};

const browserDownload = async (url: string, filename: string) => {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};

export {
    formatFileSize,
    browserDownload,
};
